<template>
    <div
        ref="bannerEl"
        role="region"
        aria-label="Dashboard retirement notice"
        class="shrink-0 bg-amber-300 px-4 py-2.5 text-sm text-slate-900 sm:px-6 lg:px-8"
    >
        <div class="mx-auto flex max-w-9xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
            <div class="flex items-start gap-3">
                <svg class="mt-[3px] h-4 w-4 shrink-0 fill-current opacity-80" viewBox="0 0 16 16" aria-hidden="true">
                    <path
                        d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"
                    />
                </svg>
                <p>
                    <span class="font-semibold">This dashboard is shutting down soon.</span>
                    Streamforge has moved to
                    <a :href="NEW_DASHBOARD_URL" class="font-semibold underline hover:no-underline" @click="trackClick('link')">
                        app.streamforge.com</a>. Sign in with your same email and password.
                </p>
            </div>
            <a
                :href="NEW_DASHBOARD_URL"
                class="shrink-0 self-start rounded bg-slate-900 px-3 py-1.5 font-medium text-white shadow-sm transition-colors hover:bg-slate-700 sm:self-auto"
                @click="trackClick('button')"
            >
                Open the new dashboard &rarr;
            </a>
        </div>
    </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { AnalyticalEvents, trackEvent } from '@/utils/analytics'
import { NEW_DASHBOARD_URL } from '@/utils/legacyRetirement'

// Full-height layouts subtract --legacy-banner-height from 100vh, so the banner never pushes their bottom edge off screen.
const bannerEl = ref(null)
let resizeObserver = null

const syncBannerHeight = () => {
    document.documentElement.style.setProperty('--legacy-banner-height', `${bannerEl.value.offsetHeight}px`)
}

onMounted(() => {
    syncBannerHeight()
    resizeObserver = new ResizeObserver(syncBannerHeight)
    resizeObserver.observe(bannerEl.value)
})

onBeforeUnmount(() => {
    resizeObserver?.disconnect()
    document.documentElement.style.removeProperty('--legacy-banner-height')
})

const trackClick = (target) => {
    trackEvent(AnalyticalEvents.LegacyRetirementBannerClicked, { target })
}
</script>
